/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Role_RemovedInputs */

const en_admin_users_role_removed = /** @type {(inputs: Admin_Users_Role_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role removed`)
};

const zh_admin_users_role_removed = /** @type {(inputs: Admin_Users_Role_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色已移除`)
};

/**
* | output |
* | --- |
* | "Role removed" |
*
* @param {Admin_Users_Role_RemovedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_role_removed = /** @type {((inputs?: Admin_Users_Role_RemovedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Role_RemovedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_role_removed(inputs)
	return zh_admin_users_role_removed(inputs)
});
export { admin_users_role_removed as "admin.users.role_removed" }